export default __webpack_public_path__ + "static/media/img-nolist.054123c6.png";